import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AppContext } from "../context/AppContext";

/**
 * allow: array of allowed role strings
 * example: <RequireRole allow={["admin"]}>...</RequireRole>
 */
export default function RequireRole({ allow = [], children }) {
  const { user, SiteConfig, loadingApp } = useContext(AppContext);
  const location = useLocation();

  if (loadingApp) return null;

  const role =
    SiteConfig?.CURRENT_USER_ROLE ??
    user?.role ??
    user?.UserRole ??
    user?.UserRoleName ??
    null;

  const roleNorm = role ? String(role).toLowerCase() : "";
  const allowNorm = allow.map((r) => String(r).toLowerCase());

  const ok = allowNorm.length === 0 || allowNorm.includes(roleNorm);
  if (!ok) {
    return <Navigate to="/unauthorized" replace state={{ from: location }} />;
  }

  return children;
}
